import { motion } from "framer-motion";

export function QualityRing({ score = 0, size = 88 }) {
  const r = 34;
  const c = 2 * Math.PI * r;
  const offset = c - (score / 100) * c;
  const color = score >= 80 ? "#34C759" : score >= 55 ? "#FF9F0A" : "#FF3B30";
  return (
    <div className="relative" style={{ height: size, width: size }} data-testid="quality-ring">
      <svg className="-rotate-90" width={size} height={size} viewBox="0 0 80 80">
        <circle cx="40" cy="40" r={r} stroke="rgba(0,0,0,0.06)" strokeWidth="7" fill="none" />
        <motion.circle
          cx="40" cy="40" r={r} stroke={color} strokeWidth="7" fill="none" strokeLinecap="round"
          strokeDasharray={c} initial={{ strokeDashoffset: c }} animate={{ strokeDashoffset: offset }}
          transition={{ duration: 1, ease: "easeOut" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-display text-2xl font-semibold text-ink" data-testid="quality-score">{score}</span>
        <span className="text-[10px] font-medium uppercase tracking-wider text-mist">score</span>
      </div>
    </div>
  );
}
